export default __webpack_public_path__ + "ecf22fb83661359fd0494378d752207b.png";